import React from "react";
import { Fade } from "react-awesome-reveal";
import Header from "parts/Header";
import Discuss from "parts/Discuss";
import Footer from "parts/Footer";
import ECA from "assets/images/customers/1ECA.png";
import RCP from "assets/images/customers/1RCP.png";
import SAE from "assets/images/customers/1SAE.png";
import EAHF from "assets/images/customers/1EAHF.png";

export default function Customers() {
  return (
    <>
      <Header />
      <section className="min-h-screen text-gray-800 py-16 px-4 md:px-10">
        {/* Title */}
        <div className="text-center mb-16">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl font-extrabold text-green-800 mb-6 text-shadow-xl transform transition-all duration-500 ease-in-out">
              Our Customers
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed opacity-80">
              Some of our big customers who are working with us currently are
              the following
            </p>
          </Fade>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-12 text-center">
          <Fade direction="up" triggerOnce>
            <div className="border-2 border-green-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={SAE}
                alt="SAE"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-green-800">
                South Africa Embassy
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-green-500 rounded-lg p-3 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={ECA}
                alt="ECA"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-green-800">
                Ethiopian Civil Aviation
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-green-500 rounded-lg p-3 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={RCP}
                alt="RCP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-green-800">
                Rama construction PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-green-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={EAHF}
                alt="EAHF"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-green-800">
                Ethio Agri-Ceft Head quarter and flower farm
              </h3>
            </div>
          </Fade>
        </div>
      </section>

      <Discuss />
      <Footer />
    </>
  );
}
